import React from "react";
import {
  Row,
  Col,
  Typography,
  Divider,
  Tag,
  List,
  Space,
  Drawer,
  Rate,
} from "antd";
import moment from "dayjs";

const { Title, Text } = Typography;

interface AnswerItem {
  order: number;
  title: string;
  answer: any;
  type?: string;
}

interface SurveyRecord {
  id: number;
  customerId: number;
  surveyId: number;
  customerName: string;
  customerPhone: string;
  surveyTitle: string;
  answers: AnswerItem[];
  createdAt: number;
  updatedAt: number;
}

interface SurveyAnswerCtrlProps {
  record: SurveyRecord;
  onClose?: (v: boolean) => void;
  drawerVisible: boolean;
  pageInfo?: any;
  query?: any;
}

const SurveyAnswerCtrl: React.FC<SurveyAnswerCtrlProps> = (props) => {
  const { record, drawerVisible, onClose } = props;

  const handleClose = () => {
    if (onClose) {
      onClose(false);
    }
  };

  if (!record && drawerVisible) {
    return (
      <Drawer
        width={640}
        // title="Chi tiết khảo sát"
        placement="right"
        closable={true}
        onClose={handleClose}
        visible={drawerVisible}
      >
        <Text type="danger">Không có dữ liệu khảo sát</Text>
      </Drawer>
    );
  }

  const renderAnswerContent = (answer: any, type?: string) => {
    if (type === "rating" || type === "RATING") {
      return <Rate disabled defaultValue={Number(answer)} />;
    }

    if (answer === null || answer === undefined || answer === "") {
      return (
        <Text italic type="secondary">
          (Không có câu trả lời)
        </Text>
      );
    }

    if (Array.isArray(answer)) {
      return (
        <Space wrap size={[0, 8]}>
          {answer.map((item, index) => (
            <Tag color="blue" key={index}>
              {String(item)}
            </Tag>
          ))}
        </Space>
      );
    }

    if (typeof answer === "boolean") {
      return (
        <Tag color={answer ? "green" : "red"}>{answer ? "Có" : "Không"}</Tag>
      );
    }

    return <Text>{String(answer)}</Text>;
  };

  return (
    <Drawer
      width={800}
      //   title={
      //     <span style={{ textTransform: "uppercase" }}>Chi tiết khảo sát</span>
      //   }
      placement="right"
      closable={true}
      onClose={handleClose}
      visible={drawerVisible}
    >
      <div className="survey-answer-detail">
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Title
            level={3}
            style={{
              marginBottom: 8,
              textTransform: "uppercase",
            }}
          >
            {record?.surveyTitle}
          </Title>
          <Text type="secondary">
            Ngày thực hiện:{" "}
            {record?.createdAt
              ? moment(record.createdAt).format("DD/MM/YYYY HH:mm")
              : "-"}
          </Text>
        </div>

        <div
          style={{
            background: "#f9f9f9",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: 24,
          }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary">Khách hàng:</Text>
              </div>
              <Title level={5} style={{ margin: 0 }}>
                {record?.customerName}
              </Title>
            </Col>
            <Col xs={24} sm={12}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary">Số điện thoại:</Text>
              </div>
              <Title level={5} style={{ margin: 0 }}>
                {record?.customerPhone}
              </Title>
            </Col>
          </Row>
        </div>

        <Divider orientation="left">
          <Text strong style={{ fontSize: "16px" }}>
            NỘI DUNG TRẢ LỜI
          </Text>
        </Divider>

        <List
          dataSource={record?.answers || []}
          split={true}
          renderItem={(item) => (
            <List.Item
              key={item.order}
              style={{
                display: "block",
                padding: "20px 0",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <div style={{ display: "flex", marginBottom: 12 }}>
                <div
                  style={{
                    minWidth: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    background: "#f09b1b",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    fontWeight: "bold",
                    flexShrink: 0,
                    fontSize: "14px",
                    color: "#fff",
                  }}
                >
                  {item.order + 1}
                </div>
                <Text strong style={{ fontSize: "15px", lineHeight: "1.6" }}>
                  {item.title}
                </Text>
              </div>
              <div style={{ paddingLeft: "40px" }}>
                {renderAnswerContent(item.answer, item.type)}
              </div>
            </List.Item>
          )}
        />
      </div>
    </Drawer>
  );
};

export default SurveyAnswerCtrl;
